export default __webpack_public_path__ + "static/media/ic-crypto.15cb6076.svg";